<template>
	<div>
		<v-text-field
			browser-autocomplete="off"
			label="label pola"
			aria-label="label"
			for="list-multi-choice-props-label"
			id="list-multi-choice-props-label"
			v-model="fieldProps.label"
			class="text-xs-center"
			outline>
		</v-text-field>
		<v-text-field
			browser-autocomplete="off"
			label="hint"
			aria-label="hint"
			for="list-multi-choice-props-hint"
			id="list-multi-choice-props-hint"
			v-model="fieldProps.hint"
			class="text-xs-center"
			outline>
		</v-text-field>
		<v-text-field
			aria-label="chip name"
			browser-autocomplete="off"
			label="Nazwa wyboru"
			for="list-multi-choice-props-choice-name"
			id="list-multi-choice-props-choice-name"
			v-model="chipName"
			class="text-xs-center"
			outline>
		</v-text-field>
		<v-btn @click="addNewChip(chipName)">Dodaj</v-btn>
		<div class="text-xs-center">
			<v-chip
				v-for="(option, index) in chips"
				v-bind:key="index"
				v-model="option.model"
				@input="removeChip(index)"
				close
			>{{option.name}}
				<v-icon @click="moveChipUp(index)" flat v-if="isNotFirst(index)">
					arrow_left
				</v-icon>

				<v-icon @click="moveChipDown(index)" flat
					v-if="isNotLast(index)">
					arrow_right
				</v-icon>
			</v-chip>
		</div>
		<v-text-field
			browser-autocomplete="off"
			label="minimalna liczba wyborów"
			aria-label="min number choice"
			for="list-multi-choice-props-min-number-choice"
			id="list-multi-choice-props-min-number-choice"
			v-model="fieldProps.min"
			type="number"
			class="text-xs-center"
			outline>
		</v-text-field>
		<v-text-field
			browser-autocomplete="off"
			label="maksymalna liczba wyborów"
			aria-label="max number choice"
			for="list-multi-choice-props-max-number-choice"
			id="list-multi-choice-props-max-number-choice"
			v-model="fieldProps.max"
			type="number"
			class="text-xs-center"
			outline>
		</v-text-field>
		<v-checkbox v-model="fieldProps.required" :label="`Wymagane`" aria-label="mandatory"></v-checkbox>
		<v-checkbox v-model="fieldProps.view" :label="`Wyświetlanie na podglądzie`"
			aria-label="show on print view"></v-checkbox>
	</div>

</template>
<script>
	export default {
		name: "listMultiChoiceProps",

		props: {
			value: Object,
			edit: {
				type: Boolean,
			},
		},


		created() {
			// inicjalizujemy chipsy
			if (this.edit) {
				this.chips = this.fieldProps.options.map(option => {
					return {name: option, model: true};
				});
			}
		},


		methods: {

			isNotLast(index) {
				return this.chips.length > 0 && index !== this.chips.length - 1;
			},

			isNotFirst(index) {
				return index !== 0;
			},

			removeChip(index) {
				confirm("Czy na pewno chcesz usunąć wybór - " + this.chips[index].name) && this.chips.splice(index, 1);
			},

			moveChipUp(index) {
				this.swapTwoArrayElements(this.chips, index - 1, index);

				// podczas edycji cos sie nie odwiezaja opcje ktore sa potem zapisywane, brzydki hak
				this.fieldProps.options = this.chips.map(chip => chip.name);
			},

			moveChipDown(index) {
				this.swapTwoArrayElements(this.chips, index + 1, index);

				// podczas edycji cos sie nie odwiezaja opcje ktore sa potem zapisywane, brzydki hak
				this.fieldProps.options = this.chips.map(chip => chip.name);
			},
			swapTwoArrayElements(array, index1, index2) {
				array = [array[index1], array[index2]] = [array[index2], array[index1]];
				this.$forceUpdate();
			},

			addNewChip(chipName) {
				if (chipName === "" || this.chipWithSameNameExists(chipName)) {
					return;
				}
				this.chips.push({name: this.chipName, model: true});
				this.chipName = "";
			},
			chipWithSameNameExists(name) {
				return this.chips.some(e => e.name === name);
			},
		},

		data() {
			return {
				fieldProps: this.value,
				chips: [],
				chipName: "",
			};
		},

		watch: {
			fieldProps: {
				handler() {
					this.$emit("input", this.fieldProps);
				},
				deep: true,
			},
			chips: {
				handler() {
					this.fieldProps.options = this.chips.map(chip => chip.name);
				},
			},
		},
	};
</script>

<style>
	.new-field .v-chip__content {
		height: auto;
		min-height: 32px;
		white-space: initial;
	}
</style>
